/**
 * Pure helpers for gate overrides. CR-2026-GATE-OVERRIDE (2026-10-14). Exported for tests.
 */
export const TYPE_LABEL = {
  HEAT_ISSUE: "Heat issue (quarantined or at-risk heat, single use)",
  FABRICATION_GATE: "Fabrication gate (marks without a heat link, time-limited)",
  CLOSEOUT: "Job closeout without the final quality data package (single use)",
  REOPEN: "Reopen a completed job (single use, spec §6.2)",
  CONTRACT_REVIEW: "Contract review gate (F1.6.0 not accepted, time-limited)",
};
export const STATUS_COLOR = { REQUESTED: "warning", COSIGNED: "info", USED: "default", REJECTED: "error", EXPIRED: "default" };

/** Client-side check before POST /gate-overrides. Returns an error message or null. The server decides. */
export function requestProblem(f) {
  if (!f.type) return "Choose the override type.";
  if (!f.jobId) return "Choose the job.";
  if (f.type === "HEAT_ISSUE" && !f.heatId) return "Choose the heat.";
  if (!["CLOSEOUT", "REOPEN", "CONTRACT_REVIEW"].includes(f.type)) {
    const n = f.type === "HEAT_ISSUE" ? (f.pieceIds || []).length : (f.itemIds || []).length;
    if (!n) return f.type === "HEAT_ISSUE" ? "Choose the pieces." : "Choose the marks.";
    if (n > 50) return "At most 50 per override.";
  }
  if (String(f.reason || "").trim().length < 10) return "Give the reason (at least 10 characters). It prints on the Daily Red Report.";
  const h = Number(f.hours);
  if (!Number.isInteger(h) || h < 1 || h > 72) return "The window is 1 to 72 hours.";
  return null;
}

/** The POST /gate-overrides body. */
export function requestBody(f) {
  const b = { type: f.type, jobId: Number(f.jobId), reason: String(f.reason).trim(), hours: Number(f.hours) };
  if (f.type === "HEAT_ISSUE") { b.heatId = Number(f.heatId); b.pieceIds = f.pieceIds.map(Number); } else if (f.type === "FABRICATION_GATE") { b.itemIds = f.itemIds.map(Number); }
  return b;
}

/** May this user co-sign this override? QC permission, still requested, and not their own request (two-person rule). */
export function canCosign(o, userId, perms) {
  return perms.includes("cosign_gate_override") && o.status === "REQUESTED" && Number(o.requestedBy) !== Number(userId);
}

/** Co-signed HEAT_ISSUE overrides usable for this heat now. */
export function usableHeatOverrides(list, heatId, now = new Date()) {
  return (list || []).filter((o) => o.type === "HEAT_ISSUE" && o.status === "COSIGNED" && Number(o.heatId) === Number(heatId)
    && o.expiresAt && new Date(o.expiresAt) > now);
}
